import React, { useContext, useState, useEffect } from 'react';
import propTypes from 'prop-types';
import usePost from '../Hooks/usePost';
import axios from 'axios';
const AuthContext = React.createContext();

export function useAuth() {
    return useContext(AuthContext);
}

export function AuthProvider({ children }) {
    const { post } = usePost('/login');
    const defaultCurrentUser = {
        isAuthenticated: null,
        emailIsVerified: false,
        accountIsComplete: false,
        accessToken: null,
        tokenExpiry: null,
    };
    const [currentUser, setCurrentUser] = useState(defaultCurrentUser);

    const token = localStorage.getItem('token');
    const tokenExpiry = localStorage.getItem('tokenExpiry');
    const currentDate = new Date().toISOString();

    const options = {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json;charset=UTF-8',
            Authorization: `Bearer ${token}`,
        },
    };

    const validateToken = async () => {
        try {
            const tokenData = await axios.get(
                `${process.env.REACT_APP_API_BASE_URL}/validateToken`,
                options
            );
            if (tokenData.data.isAuthenticated) {
                setCurrentUser({
                    ...currentUser,
                    emailIsVerified: tokenData.data.emailIsVerified,
                    accountIsComplete: tokenData.data.enrollmentIsComplete,
                    isAuthenticated: tokenData.data.isAuthenticated,
                    accessToken: token,
                    tokenExpiry,
                });
            } else {
                logout();
            }
        } catch (err) {
            console.log(err, 'err');
        }
    };

    function logout() {
        localStorage.removeItem('token');
        localStorage.removeItem('tokenExpiry');
        localStorage.removeItem('planTypePrice');
        localStorage.removeItem('planTypeDuration');
        localStorage.removeItem('planTypeName');
        localStorage.removeItem('planTypeId');
        localStorage.removeItem('firstTimeSignIn');

        return setCurrentUser({
            ...defaultCurrentUser,
            isAuthenticated: false,
        });
    }

    const login = async (email, password) => {
        const loginResponse = await post(
            {
                email,
                password,
            },
            'POST'
        );
        const token = loginResponse.data.bearerToken;
        const tokenExpiry = loginResponse.data.tokenExpiresOn;
        const isAuthenticated = loginResponse.data.authenticated;

        if (isAuthenticated && token) {
            const options = {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    Authorization: `Bearer ${token}`,
                },
            };
            const tokenData = await axios.get(
                `${process.env.REACT_APP_API_BASE_URL}/validateToken`,
                options
            );

            // set token to localStorage
            localStorage.setItem('token', token);
            localStorage.setItem('tokenExpiry', tokenExpiry);

            setCurrentUser({
                isAuthenticated,
                emailIsVerified: tokenData.data.emailIsVerified,
                accountIsComplete: tokenData.data.enrollmentIsComplete,
                accessToken: token,
                tokenExpiry,
            });
        }
        return loginResponse;
    };

    useEffect(() => {
        if (token) {
            if (currentDate < tokenExpiry) {
                // token is valid
                validateToken();
            } else {
                // token is expired logout user
                logout();
            }
        } else {
            logout();
        }
    }, []);

    const value = {
        currentUser,
        setCurrentUser,
        logout,
        login,
    };

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

AuthProvider.propTypes = {
    children: propTypes.node.isRequired,
};
